import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { creatorListingsPath, serviceCreatorStagePath } from "@travily/routes";
import type ListingsCreatorDescription from "@travily/types/pages/ListingsCreatorDescription";
import { useCreatorTopBarActions } from "@/lib/wizard/use-creator-top-bar-actions";
import { useWizardForm } from "@/lib/wizard/use-wizard-form";
import { ServiceDescriptionStepView } from "./show.view";

type PageProps = ListingsCreatorDescription;

type FormData = {
  description: string;
};

const ServiceDescriptionStep = ({ listing_id, stage_index, stage_order, description }: PageProps) => {
  const { form, validate, fieldError, currentStage, totalStages, onBack, onPrimary, primaryPending } =
    useWizardForm<FormData>({
      routes: {
        stageUrl: (stage) => serviceCreatorStagePath(listing_id, stage),
        entryUrl: creatorListingsPath(),
      },
      stageName: "description",
      stageIndex: stage_index,
      stageOrder: stage_order,
      initialData: { description: description ?? "" },
    });

  const descriptionError = fieldError("description");

  const topBarActions = useCreatorTopBarActions({ saveHref: creatorListingsPath() });

  return (
    <>
      <Head title={t("web.services.creator.steps.description.show.meta_title")}>
        <meta name="description" content={t("web.services.creator.steps.description.show.meta_description")} />
      </Head>
      <ServiceDescriptionStepView
        currentStage={currentStage}
        totalStages={totalStages}
        onBack={onBack}
        topBarActions={topBarActions}
        onPrimary={onPrimary}
        primaryPending={primaryPending}
        description={form.data.description}
        error={descriptionError}
        onDescriptionChange={(val) => {
          form.setData("description", val);
          validate("description");
        }}
      />
    </>
  );
};

export default ServiceDescriptionStep;
